<template>
  <div>
    <el-dialog
      title="Thanh toán"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="1000px"
      @close="onResetData"
    >
      <el-tabs
        v-model="tabIndex"
        tab-position="left"
        style="height: 400px"
        @tab-click="onTabClick"
      >
        <el-tab-pane
          v-for="(item, index) in paymentConfigs"
          :key="index"
          :label="item.name"
        >
          <!-- Check debt account is zero or not -->
          <div
            v-if="index === 2 && debtAccounts.length === 0"
            style="color: red"
          >
            Đặt phòng này không được phép thanh toán bằng công nợ.
          </div>
          <div v-else class="das-form-container">
            <InfoList :columns="2">
              <InfoListLabel>
                <span>Ngày</span>
              </InfoListLabel>
              <InfoListValue>
                <span>{{ $displayDate(new Date()) }}</span>
              </InfoListValue>

              <InfoListLabel>
                <span>Trang giao dịch</span>
              </InfoListLabel>
              <InfoListValue>{{
                `${selectedTab?.label} - ${selectedTab?.desc}`
              }}</InfoListValue>

              <InfoListLabel>Tên khách</InfoListLabel>
              <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

              <InfoListLabel>Thu ngân</InfoListLabel>
              <InfoListValue>{{ userName ?? 'Unknown' }}</InfoListValue>

              <InfoListLabel>
                <span class="label-required">Số tiền</span>
              </InfoListLabel>
              <InfoListValue
                ><div style="display: flex; align-items: center; gap: 10px">
                  <VxCurrencyInput
                    v-if="roomPaymentForm.currency_id === 5"
                    v-model="roomPaymentForm.moneyArr[index]"
                    style="flex: 2"
                  />
                  <div v-else class="flex" style="flex: 2">
                    <VxCurrencyInput
                      v-model="forexPayment.moneyDecimal"
                      style="flex: 3"
                    />
                    <span
                      style="
                        margin: 0 3px;
                        align-self: end;
                        font-size: 20px;
                        font-weight: 700;
                        transform: translateY(4px);
                      "
                      >.</span
                    >
                    <input
                      v-model="forexPayment.precision"
                      type="text"
                      style="flex: 1"
                    />
                  </div>
                  <el-select
                    v-model="roomPaymentForm.currency_id"
                    style="flex: 1"
                    placeholder=""
                  >
                    <el-option
                      v-for="item1 in currencyOptions"
                      :key="item1.id"
                      :label="item1.code"
                      :value="item1.id"
                    >
                    </el-option>
                  </el-select></div
              ></InfoListValue>
              <InfoListLabel
                ><span class="label-required">Loại</span></InfoListLabel
              >
              <InfoListValue>
                <el-select
                  v-model="roomPaymentForm.subTransactionIdArr[index]"
                  placeholder=""
                >
                  <el-option
                    v-for="item1 in paymentOptions"
                    :key="item1.c_sub_transaction_id"
                    :label="`${item1.c_sub_transaction_nm} - ${item1.c_sub_transaction_desc}`"
                    :value="item1.c_sub_transaction_id"
                  >
                  </el-option>
                </el-select>
              </InfoListValue>
              <InfoListLabel v-if="roomPaymentForm.currency_id != 5"
                >Quy đổi ra VND</InfoListLabel
              >
              <InfoListValue v-if="roomPaymentForm.currency_id != 5"
                >{{ $displayCurrency(exchangedAmount) || 0 }} VND</InfoListValue
              >
              <InfoListLabel>Số dư</InfoListLabel>
              <InfoListValue
                ><span
                  class="value"
                  style="
                    color: #357456;
                    font-weight: 700;
                    cursor: pointer;
                    user-select: none;
                  "
                  @click="surplusOnClicked(index)"
                  >{{
                    $displayCurrency(roomPaymentForm.leftMoney) || 0
                  }}
                  VND</span
                ></InfoListValue
              >
              <!-- Transfer Payment -->
              <template v-if="index === 1">
                <InfoListLabel
                  ><span class="label-required"
                    >Tài khoản nhận</span
                  ></InfoListLabel
                >
                <InfoListValue>
                  <select-with-search-table
                    style="width: 100%"
                    :dropdown-width="400"
                    :rows="bankAccOptions"
                    :columns="selectSearchCol"
                    :search-fields="['code']"
                    :value="roomPaymentForm.bank_account_id[1]"
                    :selected-index-field-value="
                      roomPaymentForm.bank_account_id[1]
                    "
                    index-field="id"
                    @selectionChanged="onSelectRowOption($event, index)"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.name }}
                    </template>
                  </select-with-search-table>
                </InfoListValue>
              </template>
              <!-- Debt Payment -->
              <template v-if="index === 2">
                <InfoListLabel
                  ><span class="label-required"
                    >Tài khoản công nợ</span
                  ></InfoListLabel
                >
                <InfoListValue>
                  <el-select
                    v-model="roomPaymentForm.debt_account_id"
                    placeholder=""
                  >
                    <el-option
                      v-for="option in debtAccounts"
                      :key="option.id"
                      :label="option.name"
                      :value="option.id"
                    />
                  </el-select>
                  <!-- <select-with-search-table
                  style="width: 100%"
                  :rows="bankAccOptions"
                  :columns="selectSearchCol"
                  :search-fields="['code']"
                  :value="roomPaymentForm.bank_account_id"
                  :selected-index-field-value="roomPaymentForm.bank_account_id"
                  index-field="id"
                  @selectionChanged="onSelectRowOption"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    {{ selectedData?.id }}
                  </template>
                </select-with-search-table> -->
                </InfoListValue>
              </template>
              <!-- Card Payment -->
              <template v-if="index === 3">
                <!-- <InfoListLabel
                  ><span class="label-required">Số thẻ</span></InfoListLabel
                >
                <InfoListValue
                  ><input v-model="roomPaymentForm.card_num" type="text"
                /></InfoListValue> -->

                <InfoListLabel
                  ><span class="label">Tên ngân hàng</span></InfoListLabel
                >
                <InfoListValue
                  ><input v-model="roomPaymentForm.bank_name" type="text"
                /></InfoListValue>

                <!-- <InfoListLabel
                  ><span class="label">Ngày hết hạn thẻ</span></InfoListLabel
                >
                <InfoListValue
                  ><input
                    v-model="roomPaymentForm.card_num_expired"
                    type="text"
                /></InfoListValue> -->
              </template>

              <InfoListLabel>Ghi chú</InfoListLabel>
              <InfoListValue>
                <textarea
                  v-model="roomPaymentForm.note"
                  style="width: 100%"
                  :rows="3"
                />
              </InfoListValue>

              <template v-if="index === 3">
                <InfoListLabel
                  ><span class="label-required"
                    >Tài khoản nhận</span
                  ></InfoListLabel
                >
                <InfoListValue>
                  <select-with-search-table
                    style="width: 100%"
                    :dropdown-width="400"
                    :rows="bankAccOptions"
                    :columns="selectSearchCol"
                    :search-fields="['code']"
                    :value="roomPaymentForm.bank_account_id[3]"
                    :selected-index-field-value="
                      roomPaymentForm.bank_account_id[3]
                    "
                    index-field="id"
                    @selectionChanged="onSelectRowOption($event, index)"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.name }}
                    </template>
                  </select-with-search-table>
                </InfoListValue>
              </template>
            </InfoList>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            Đóng
          </button>
          <button
            class="btn primary small"
            :disabled="roomPaymentForm.leftMoney !== 0"
            @click="submitPaymentForm"
          >
            Thanh toán
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { getAllCurrencyApi } from '@/api/common/currency'
import { getListPMSBankAccountApi } from '@/api/configuration/accounting/bankAccount.js'
import {
  getTransactionConfig,
  getMoneyPaymentApi,
  // eslint-disable-next-line no-unused-vars
  addRoomTransaction,
  getDebtAccountsApi
} from '@/api/cashier_service/postTransaction'
export default {
  props: {
    types: {
      type: String,
      default: null
    },
    keyA: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      dialogFormVisible: false,
      tabIndex: '0',
      debtAccounts: [],
      leftSurplusAmount: 0,
      selectSearchCol: [
        {
          headerName: 'Mã tài khoản',
          field: 'code'
        },
        {
          headerName: 'Tên ngân hàng',
          field: 'name'
        },
        {
          headerName: 'Số tài khoản',
          field: 'acc_num'
        }
      ],
      bankAccOptions: [],
      payments: [],
      currencyOptions: [],
      paymentOptions: [],
      paymentMethods: [],
      isVTab: false,
      forexPayment: {
        moneyDecimal: null,
        precision: null
      },
      roomPaymentForm: {
        money: 0,
        moneyArr: [0, 0, 0, 0, 0],
        subTransactionIdArr: [null, null, null, null],
        currency_id: 5,
        leftMoney: 0,
        note: null,
        sub_booking_group_id: 70,
        sub_transaction_id: null,
        trans_date: null,
        trans_page: null,
        invoice_num: null,
        debt_account_id: null,
        bank_account_id: [null, null, null, null],
        card_num: null,
        bank_name: null,
        card_num_expired: null
      },
      paymentTransactionConfig: [],
      paymentConfigs: [
        {
          name: 'Tiền mặt'
        },
        {
          name: 'Chuyển khoản'
        },
        {
          name: 'Công nợ'
        },
        {
          name: 'Thẻ'
        }
      ]
    }
  },
  computed: {
    // tabList() {
    //   return this.$store.getters['tabList']
    // },
    allTranPages() {
      return this.$store.getters['allTranPages']
    },
    bookingInfo() {
      return this.$store.getters['cashier']
    },
    selectedTab() {
      return this.$store.getters['selectedTab']
    },
    transactions() {
      return this.$store.getters['transactions']
    },
    exchangedAmount() {
      const data = this.currencyOptions.filter(
        // eslint-disable-next-line eqeqeq
        item => item.id == this.roomPaymentForm.currency_id
      )
      const rate = Number(data[0]?.exchange_rate || 0)
      return this.roomPaymentForm.moneyArr * rate
    },
    userName() {
      return this.$store.getters['full_name']
    }
  },
  watch: {
    async keyA() {
      // open dialog
      await this.getMoneyPayment()
      await this.getTransactionConfigList()
      await this.getAllCurrency()
      await this.getBankAccounts()
      this.setInit()
    },
    'roomPaymentForm.currency_id'() {
      this.roomPaymentForm.moneyArr = 0
    },
    'roomPaymentForm.moneyArr'() {
      // use reduce
      const amount = this.roomPaymentForm.moneyArr.reduce(
        (a, b) => a - b,
        this.leftSurplusAmount
      )
      this.roomPaymentForm.leftMoney = amount
      this.$emit('surplusChange', amount)
      // alert(1)
    }
  },
  async mounted() {
    // this.fillInitData()
  },
  methods: {
    // cardNumValidated() {
    //   let validated = true
    //   if (
    //     this.roomPaymentForm.moneyArr[3] &&
    //     this.roomPaymentForm.moneyArr[3] !== 0
    //   ) {
    //     if (!this.roomPaymentForm.card_num) {
    //       this.$message({
    //         message: 'Trường số thẻ tại mục thẻ là trường bắt buộc',
    //         type: 'error'
    //       })
    //       validated = false
    //     } else if (isNaN(this.roomPaymentForm.card_num)) {
    //       this.$message({
    //         message: 'Trường số thẻ bắt buộc là số',
    //         type: 'error'
    //       })
    //       validated = false
    //     } else if (this.roomPaymentForm.card_num.length > 20) {
    //       this.$message({
    //         message: 'Độ dài của trường thẻ nhỏ hơn 20 kí tự',
    //         type: 'error'
    //       })
    //       validated = false
    //     }
    //   }
    //   return validated
    // },
    async getAllCurrency() {
      // const data = await getAllCurrencyApi()
      this.currencyOptions = [
        {
          id: 5,
          code: 'VND'
        }
      ]
    },
    debtPaymentChecked() {
      let validated = true
      const debtPaymentAmount = this.roomPaymentForm.moneyArr[2]
      if (debtPaymentAmount) {
        const totalAmount = this.roomPaymentForm.moneyArr.reduce(
          (a, b) => a + b,
          0
        )
        if (totalAmount !== debtPaymentAmount) {
          validated = false
          this.$message({
            message:
              'Không thể kết hợp thanh toán bằng công nợ kèm các phương thức khác',
            type: 'error'
          })
        }
      } else {
        this.roomPaymentForm.debt_account_id = null
      }
      return validated
    },
    async openDialog() {
      await this.getMoneyPayment()
      await this.getTransactionConfigList()
      await this.getAllCurrency()
      await this.getBankAccounts()
      this.setInit()
      this.dialogFormVisible = true
    },
    setInit() {
      this.tabIndex = '0'
      // SET INIT FOR CASH PAYMENT
      this.paymentOptions = this.paymentTransactionConfig.filter(
        item => item.method_nm === 'CASH_PAYMENT'
      )
      this.roomPaymentForm.subTransactionIdArr[0] =
        this.paymentOptions[0]?.c_sub_transaction_id
      // eslint-disable-next-line
      const paymentOptions1 = this.paymentTransactionConfig.filter(
        item => item.method_nm === 'TRANSFER_PAYMENT'
      )
      // SET INIT FOR TRANSFER PAYMENT
      this.roomPaymentForm.subTransactionIdArr[1] =
        paymentOptions1[0]?.c_sub_transaction_id
      this.roomPaymentForm.bank_account_id[1] = this.bankAccOptions[0].id
      this.roomPaymentForm.bank_account_id[3] = this.bankAccOptions[0].id
      // SET INIT FOR DEBT PAYMENT
      // eslint-disable-next-line
      const paymentOptions2 = this.paymentTransactionConfig.filter(
        item => item.method_nm === 'DEBT_PAYMENT_HOTEL'
      )
      this.roomPaymentForm.subTransactionIdArr[2] =
        paymentOptions2[0]?.c_sub_transaction_id
      // SET INIT FOR CARD PAYMENT
      // eslint-disable-next-line
      const paymentOptions3 = this.paymentTransactionConfig.filter(
        item => item.method_nm === 'PREPAID_CARD_PAYMENT'
      )
      this.roomPaymentForm.subTransactionIdArr[3] =
        paymentOptions3[0]?.c_sub_transaction_id
    },
    surplusOnClicked(index) {
      if (this.roomPaymentForm.leftMoney === 0) {
        this.$message({
          message: 'Không thể thanh toán số tiền 0',
          type: 'error'
        })
        return
      } else {
        this.roomPaymentForm.moneyArr[index] += this.roomPaymentForm.leftMoney
        this.roomPaymentForm.moneyArr = JSON.parse(
          JSON.stringify(this.roomPaymentForm.moneyArr)
        )
      }
    },
    onResetData() {
      this.roomPaymentForm = {
        money: 0,
        moneyArr: [0, 0, 0, 0, 0],
        subTransactionIdArr: [null, null, null, null],
        currency_id: 5,
        leftMoney: 0,
        note: null,
        sub_booking_group_id: 70,
        sub_transaction_id: null,
        trans_date: null,
        trans_page: null,
        invoice_num: null,
        debt_account_id: null,
        bank_account_id: [null, null, null, null],
        card_num: null
      }
    },
    async submitPaymentForm() {
      // if (!this.cardNumValidated()) {
      //   return
      // }
      if (!this.debtPaymentChecked()) {
        return
      }
      // conver data for paymentMethods
      const paymentMethods = []
      const availableMoneyArray = this.roomPaymentForm.moneyArr.map(
        item => item
      )
      availableMoneyArray.map((item, index) => {
        if (item !== 0) {
          paymentMethods.push({
            // ...this.roomPaymentForm,
            money: item,
            sub_transaction_id: this.roomPaymentForm.subTransactionIdArr[index],
            card_num: index === 3 ? 'truongvd' : null,
            bank_account_id: this.roomPaymentForm.bank_account_id[index],
            debt_account_id: this.roomPaymentForm.debt_account_id,
            bank_name: this.roomPaymentForm.bank_name,
            card_num_expired: this.roomPaymentForm.card_num_expired
          })
        }
      })
      // build payload
      // eslint-disable-next-line no-unused-vars
      const payload = {
        note: this.roomPaymentForm.note,
        sub_booking_group_id: this.bookingInfo.id,
        trans_date: this.$moment(new Date()).format('YYYY-MM-DD'),
        trans_page: this.selectedTab?.value || null,
        sub_booking_service_id: null,
        sub_transaction_paid: this.transactions.map(
          item => item.sub_transaction_id
        ),
        room_transaction_ids: this.transactions.map(item => item.id),
        payment_method: paymentMethods
      }
      await addRoomTransaction(payload)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.dialogFormVisible = false
          this.$store.dispatch('cashier/changeTransactionListIndex')
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async getMoneyPayment() {
      const params = {
        ids: this.transactions.map(item => item.id),
        subBookingGroupId: this.bookingInfo.id,
        transPage: this.selectedTab?.value || null
      }
      await this.getDebtAccounts()
      const data = await getMoneyPaymentApi(params)
      this.leftSurplusAmount = data.data
      this.roomPaymentForm.leftMoney = data.data
    },
    async getDebtAccounts() {
      const params = {
        subBookingGroupId: this.bookingInfo.id
      }
      const data = await getDebtAccountsApi(params)
      this.debtAccounts = data.data || []
    },
    onSelectRowOption(val, index) {
      if (index === 1) {
        // index 1 - transfer method
        // index 3 - card payment
        this.roomPaymentForm.bank_account_id[1] = val.id
      } else {
        this.roomPaymentForm.bank_account_id[3] = val.id
      }
    },
    async getBankAccounts() {
      const data = await getListPMSBankAccountApi({ active: true })
      this.bankAccOptions = data.data
    },
    async getTransactionConfigList() {
      const paymentData = await getTransactionConfig({ type: 1 })
      this.paymentTransactionConfig = paymentData?.data || []
    },

    onTabClick(params) {
      switch (Number(params.index)) {
        case 0:
          this.paymentOptions = this.paymentTransactionConfig.filter(
            item => item.method_nm === 'CASH_PAYMENT'
          )
          this.roomPaymentForm.subTransactionIdArr[0] =
            this.paymentOptions[0].c_sub_transaction_id
          break
        case 1:
          this.paymentOptions = this.paymentTransactionConfig.filter(
            item => item.method_nm === 'TRANSFER_PAYMENT'
          )
          break
        case 2:
          this.paymentOptions = this.paymentTransactionConfig.filter(
            item => item.method_nm === 'DEBT_PAYMENT_HOTEL'
          )
          this.roomPaymentForm.debt_account_id = this.debtAccounts[0]?.id
          break
        case 3:
          this.paymentOptions = this.paymentTransactionConfig.filter(
            item => item.method_nm === 'PREPAID_CARD_PAYMENT'
          )
          break
        default:
          break
      }
      this.tab = params.index
    }
  }
}
</script>
